import {
  ForcedSubject,
  MongoAbility,
  RawRuleOf,
  createMongoAbility,
} from "@casl/ability";

import { components } from "@/lib/api/schema";

export type Subjects = components["schemas"]["Subjects"];
export type Actions = components["schemas"]["Actions"];

// AppSubjects extends the bare string literals with their ForcedSubject form so
// that ability.can(action, subject("Report", { customerId })) typechecks while
// still rejecting typos like subject("Reprot", …) — the literal union is the
// constraint surface; ForcedSubject<S> is the tagged-object companion.
type AppSubjects = Subjects | ForcedSubject<Subjects> | "all";

// MongoAbility (not bare PureAbility) so the packed { customerId } conditions
// are matched — mirrors the server's createMongoAbility in buildPortusAbility.
export type AppAbility = MongoAbility<[Actions, AppSubjects]>;
export type AbilityRule = RawRuleOf<AppAbility>;

type LoggedUser = components["schemas"]["User"];

export const defineAbilitiesFor = (user?: LoggedUser): AppAbility => {
  return createMongoAbility<AppAbility>(user?.abilities ?? []);
};
